/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type pin_FullPlanAction$ref = any;
export type pin_unpinPlanAction_MutationVariables = {|
  itemId: any
|};
export type pin_unpinPlanAction_MutationResponse = {|
  +pinMutation: ?{|
    +unpin: ?{|
      +id: string,
      +actions: $ReadOnlyArray<?{|
        +id: string,
        +pinned: boolean,
        +$fragmentRefs: pin_FullPlanAction$ref,
      |}>,
    |}
  |}
|};
export type pin_unpinPlanAction_Mutation = {|
  variables: pin_unpinPlanAction_MutationVariables,
  response: pin_unpinPlanAction_MutationResponse,
|};
*/


/*
mutation pin_unpinPlanAction_Mutation(
  $itemId: UUID!
) {
  pinMutation {
    unpin(itemId: $itemId, itemType: PlanAction) {
      id
      actions {
        id
        pinned
        ...pin_FullPlanAction
      }
    }
  }
}

fragment pin_FullPlanAction on PlanAction {
  id
  text
  status
  pinned
  auditMeta {
    created
    createdBy {
      userName
      firstName
      lastName
      id
    }
    updated
    updatedBy {
      userName
      firstName
      lastName
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "itemId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "itemId",
    "variableName": "itemId"
  },
  {
    "kind": "Literal",
    "name": "itemType",
    "value": "PlanAction"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pinned",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "userName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  },
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "pin_unpinPlanAction_Mutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PinMutation",
        "kind": "LinkedField",
        "name": "pinMutation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Plan",
            "kind": "LinkedField",
            "name": "unpin",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PlanAction",
                "kind": "LinkedField",
                "name": "actions",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "pin_FullPlanAction"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "pin_unpinPlanAction_Mutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PinMutation",
        "kind": "LinkedField",
        "name": "pinMutation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Plan",
            "kind": "LinkedField",
            "name": "unpin",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PlanAction",
                "kind": "LinkedField",
                "name": "actions",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "text",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AuditMeta",
                    "kind": "LinkedField",
                    "name": "auditMeta",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "created",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AuditUser",
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": (v4/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "updated",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AuditUser",
                        "kind": "LinkedField",
                        "name": "updatedBy",
                        "plural": false,
                        "selections": (v4/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0a283f85d8d55451c46f0fae6b20fae5",
    "id": null,
    "metadata": {},
    "name": "pin_unpinPlanAction_Mutation",
    "operationKind": "mutation",
    "text": "mutation pin_unpinPlanAction_Mutation(\n  $itemId: UUID!\n) {\n  pinMutation {\n    unpin(itemId: $itemId, itemType: PlanAction) {\n      id\n      actions {\n        id\n        pinned\n        ...pin_FullPlanAction\n      }\n    }\n  }\n}\n\nfragment pin_FullPlanAction on PlanAction {\n  id\n  text\n  status\n  pinned\n  auditMeta {\n    created\n    createdBy {\n      userName\n      firstName\n      lastName\n      id\n    }\n    updated\n    updatedBy {\n      userName\n      firstName\n      lastName\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7ee6ab6bcfbfbbe0765983eb9a14ff4c';

module.exports = node;
